import React from "react";
import { useContent } from "../contexts/ContentContext";
import { HeroBackdrop, HeroActions, HeroOfficeLines } from "./HeroParts";

export default function Hero() {
  const { firm } = useContent();
  return (
    <section id="home" className="relative min-h-[100vh] flex items-center overflow-hidden">
      <HeroBackdrop />

      <div className="relative z-10 max-w-6xl mx-auto px-6 w-full pt-40 md:pt-44 pb-20 text-center">
        <div className="flex justify-center mb-10 px-2">
          <img
            src="/assets/hbhs-logo-clean-gold.png"
            alt="Hilty, Bower, Haws & Seable, PLLC"
            className="h-auto w-full max-w-[520px] md:max-w-[640px] lg:max-w-[760px] object-contain"
          />
        </div>

        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-px w-16 bg-[#b8924a]" />
          <span className="text-[11px] uppercase tracking-[0.4em] text-[#d4b87a]">Attorneys at Law &middot; Established in Idaho</span>
          <div className="h-px w-16 bg-[#b8924a]" />
        </div>

        <h1 className="font-serif text-white text-5xl md:text-7xl lg:text-[5.5rem] font-light leading-[1.1] mb-8 tracking-tight">
          A Tradition of <span className="italic">Excellence</span>
        </h1>

        <p className="max-w-3xl mx-auto text-lg md:text-xl text-stone-200 leading-relaxed font-light">
          For more than four decades, Idaho&rsquo;s families, businesses, and institutions have trusted our attorneys for experienced legal counsel &mdash; grounded in professionalism, integrity, and personal service.
        </p>

        <HeroActions />
        <HeroOfficeLines firm={firm} />
      </div>
    </section>
  );
}
